module.exports = __webpack_public_path__ + "img/Gold Nova I.d8664410.png";